// extracted by mini-css-extract-plugin
export default {"items":"styles_items__-vhsE","item":"styles_item__GkcYj"};